import { useState, useEffect } from 'react';
import { Scissors } from 'lucide-react';
import { META, ROUTES } from './data';

// Ashford & Vail Header — pattern-paper cream bg, deep red accent.
// Distinctive: brand uses a small scissor mark; nav has serif-italic labels with Roman numerals.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  const numerals = ['I', 'II', 'III', 'IV'];
  return (
    <header className={`sticky top-0 z-40 transition-all duration-700 ${scrolled ? 'bg-[#E5DDCB]/95 backdrop-blur-md border-b border-[#1F1E1B]/15 py-3' : 'bg-[#E5DDCB] py-5'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 flex items-center justify-between gap-6">
        <button onClick={() => setPage('home')} className="flex items-center gap-3" data-testid="tailor-logo">
          <Scissors className="w-4 h-4 text-[#6B2D2A]" strokeWidth={1.4} />
          <span>
            <span className="font-serif text-2xl lg:text-3xl text-[#1F1E1B]" dangerouslySetInnerHTML={{ __html: META.brand }} />
            <span className="font-mono text-[9px] tracking-[0.4em] uppercase text-[#1F1E1B]/55 block leading-tight">{META.tagline}</span>
          </span>
        </button>
        <nav className="hidden lg:flex items-center gap-9">
          {ROUTES.map((r, i) => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`tailor-nav-${r.id}`}
              className={`group flex items-baseline gap-2 transition-colors ${page === r.id ? 'text-[#6B2D2A]' : 'text-[#1F1E1B]/65 hover:text-[#1F1E1B]'}`}>
              <span className="font-serif italic text-base">{r.label}</span>
              <span className="font-serif italic text-[10px] text-[#6B2D2A]/65">{numerals[i]}</span>
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('appointment')} className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6B2D2A] border-b border-[#6B2D2A] pb-0.5 hover:text-[#1F1E1B] hover:border-[#1F1E1B]" data-testid="tailor-cta-appointment">Book a fitting →</button>
      </div>
    </header>
  );
}
